import { jsx as u } from "react/jsx-runtime";
import { S as f } from "./index.CCavb-1K.js";
import "@smart/web-foundations";
import { c as k } from "./index.rKuIKazb.js";
import v from "react";
import '../assets/layout.css';const x = (a, _) => {
  if (!_) return [];
  if (typeof _ == "object") {
    const n = [];
    return Object.entries(_).forEach(([i, d]) => {
      if (!d) return;
      (i === "x" ? ["left", "right"] : i === "y" ? ["top", "bottom"] : [i]).forEach((l) => n.push(`${a}-${l}-${d}`));
    }), n;
  }
  return [`${a}-${_}`];
};
function g(a, _) {
  if (!_) return [];
  const n = [];
  return typeof _ == "string" || typeof _ == "number" ? n.push(`${a}-${_}`) : Object.entries(_).forEach(([i, d]) => {
    if (d) {
      const o = `${a}-${d}-${i}`;
      n.push(o);
    }
  }), n;
}
const t = (a, _) => a.map((n) => _[n]).join(" ").trim(), $ = "_border_1bnae_537", e = {
  "padding-x-0": "_padding-x-0_1bnae_3",
  "padding-x-50": "_padding-x-50_1bnae_6",
  "padding-x-100": "_padding-x-100_1bnae_9",
  "padding-x-200": "_padding-x-200_1bnae_12",
  "padding-x-300": "_padding-x-300_1bnae_15",
  "padding-x-400": "_padding-x-400_1bnae_18",
  "padding-x-500": "_padding-x-500_1bnae_21",
  "padding-x-600": "_padding-x-600_1bnae_24",
  "padding-x-700": "_padding-x-700_1bnae_27",
  "padding-x-800": "_padding-x-800_1bnae_30",
  "padding-x-900": "_padding-x-900_1bnae_33",
  "padding-x-1000": "_padding-x-1000_1bnae_36",
  "padding-y-0": "_padding-y-0_1bnae_39",
  "padding-y-50": "_padding-y-50_1bnae_42",
  "padding-y-100": "_padding-y-100_1bnae_45",
  "padding-y-200": "_padding-y-200_1bnae_48",
  "padding-y-300": "_padding-y-300_1bnae_51",
  "padding-y-400": "_padding-y-400_1bnae_54",
  "padding-y-500": "_padding-y-500_1bnae_57",
  "padding-y-600": "_padding-y-600_1bnae_60",
  "padding-y-700": "_padding-y-700_1bnae_63",
  "padding-y-800": "_padding-y-800_1bnae_66",
  "padding-y-900": "_padding-y-900_1bnae_69",
  "padding-y-1000": "_padding-y-1000_1bnae_72",
  "padding-0": "_padding-0_1bnae_75",
  "padding-50": "_padding-50_1bnae_78",
  "padding-100": "_padding-100_1bnae_81",
  "padding-200": "_padding-200_1bnae_84",
  "padding-300": "_padding-300_1bnae_87",
  "padding-400": "_padding-400_1bnae_90",
  "padding-500": "_padding-500_1bnae_93",
  "padding-600": "_padding-600_1bnae_96",
  "padding-700": "_padding-700_1bnae_99",
  "padding-800": "_padding-800_1bnae_102",
  "padding-900": "_padding-900_1bnae_105",
  "padding-1000": "_padding-1000_1bnae_108",
  "padding-top-0": "_padding-top-0_1bnae_111",
  "padding-top-50": "_padding-top-50_1bnae_114",
  "padding-top-100": "_padding-top-100_1bnae_117",
  "padding-top-200": "_padding-top-200_1bnae_120",
  "padding-top-300": "_padding-top-300_1bnae_123",
  "padding-top-400": "_padding-top-400_1bnae_126",
  "padding-top-500": "_padding-top-500_1bnae_129",
  "padding-top-600": "_padding-top-600_1bnae_132",
  "padding-top-700": "_padding-top-700_1bnae_135",
  "padding-top-800": "_padding-top-800_1bnae_138",
  "padding-top-900": "_padding-top-900_1bnae_141",
  "padding-top-1000": "_padding-top-1000_1bnae_144",
  "padding-bottom-0": "_padding-bottom-0_1bnae_147",
  "padding-bottom-50": "_padding-bottom-50_1bnae_150",
  "padding-bottom-100": "_padding-bottom-100_1bnae_153",
  "padding-bottom-200": "_padding-bottom-200_1bnae_156",
  "padding-bottom-300": "_padding-bottom-300_1bnae_159",
  "padding-bottom-400": "_padding-bottom-400_1bnae_162",
  "padding-bottom-500": "_padding-bottom-500_1bnae_165",
  "padding-bottom-600": "_padding-bottom-600_1bnae_168",
  "padding-bottom-700": "_padding-bottom-700_1bnae_171",
  "padding-bottom-800": "_padding-bottom-800_1bnae_174",
  "padding-bottom-900": "_padding-bottom-900_1bnae_177",
  "padding-bottom-1000": "_padding-bottom-1000_1bnae_180",
  "padding-left-0": "_padding-left-0_1bnae_183",
  "padding-left-50": "_padding-left-50_1bnae_186",
  "padding-left-100": "_padding-left-100_1bnae_189",
  "padding-left-200": "_padding-left-200_1bnae_192",
  "padding-left-300": "_padding-left-300_1bnae_195",
  "padding-left-400": "_padding-left-400_1bnae_198",
  "padding-left-500": "_padding-left-500_1bnae_201",
  "padding-left-600": "_padding-left-600_1bnae_204",
  "padding-left-700": "_padding-left-700_1bnae_207",
  "padding-left-800": "_padding-left-800_1bnae_210",
  "padding-left-900": "_padding-left-900_1bnae_213",
  "padding-left-1000": "_padding-left-1000_1bnae_216",
  "padding-right-0": "_padding-right-0_1bnae_219",
  "padding-right-50": "_padding-right-50_1bnae_222",
  "padding-right-100": "_padding-right-100_1bnae_225",
  "padding-right-200": "_padding-right-200_1bnae_228",
  "padding-right-300": "_padding-right-300_1bnae_231",
  "padding-right-400": "_padding-right-400_1bnae_234",
  "padding-right-500": "_padding-right-500_1bnae_237",
  "padding-right-600": "_padding-right-600_1bnae_240",
  "padding-right-700": "_padding-right-700_1bnae_243",
  "padding-right-800": "_padding-right-800_1bnae_246",
  "padding-right-900": "_padding-right-900_1bnae_249",
  "padding-right-1000": "_padding-right-1000_1bnae_252",
  "margin-0": "_margin-0_1bnae_255",
  "margin-50": "_margin-50_1bnae_258",
  "margin-100": "_margin-100_1bnae_261",
  "margin-200": "_margin-200_1bnae_264",
  "margin-300": "_margin-300_1bnae_267",
  "margin-400": "_margin-400_1bnae_270",
  "margin-500": "_margin-500_1bnae_273",
  "margin-600": "_margin-600_1bnae_276",
  "margin-700": "_margin-700_1bnae_279",
  "margin-800": "_margin-800_1bnae_282",
  "margin-900": "_margin-900_1bnae_285",
  "margin-1000": "_margin-1000_1bnae_288",
  "margin-auto": "_margin-auto_1bnae_291",
  "margin-x-0": "_margin-x-0_1bnae_294",
  "margin-x-50": "_margin-x-50_1bnae_297",
  "margin-x-100": "_margin-x-100_1bnae_300",
  "margin-x-200": "_margin-x-200_1bnae_303",
  "margin-x-300": "_margin-x-300_1bnae_306",
  "margin-x-400": "_margin-x-400_1bnae_309",
  "margin-x-500": "_margin-x-500_1bnae_312",
  "margin-x-600": "_margin-x-600_1bnae_315",
  "margin-x-700": "_margin-x-700_1bnae_318",
  "margin-x-800": "_margin-x-800_1bnae_321",
  "margin-x-900": "_margin-x-900_1bnae_324",
  "margin-x-1000": "_margin-x-1000_1bnae_327",
  "margin-x-auto": "_margin-x-auto_1bnae_330",
  "margin-y-0": "_margin-y-0_1bnae_333",
  "margin-y-50": "_margin-y-50_1bnae_336",
  "margin-y-100": "_margin-y-100_1bnae_339",
  "margin-y-200": "_margin-y-200_1bnae_342",
  "margin-y-300": "_margin-y-300_1bnae_345",
  "margin-y-400": "_margin-y-400_1bnae_348",
  "margin-y-500": "_margin-y-500_1bnae_351",
  "margin-y-600": "_margin-y-600_1bnae_354",
  "margin-y-700": "_margin-y-700_1bnae_357",
  "margin-y-800": "_margin-y-800_1bnae_360",
  "margin-y-900": "_margin-y-900_1bnae_363",
  "margin-y-1000": "_margin-y-1000_1bnae_366",
  "margin-y-auto": "_margin-y-auto_1bnae_369",
  "margin-top-0": "_margin-top-0_1bnae_372",
  "margin-top-50": "_margin-top-50_1bnae_375",
  "margin-top-100": "_margin-top-100_1bnae_378",
  "margin-top-200": "_margin-top-200_1bnae_381",
  "margin-top-300": "_margin-top-300_1bnae_384",
  "margin-top-400": "_margin-top-400_1bnae_387",
  "margin-top-500": "_margin-top-500_1bnae_390",
  "margin-top-600": "_margin-top-600_1bnae_393",
  "margin-top-700": "_margin-top-700_1bnae_396",
  "margin-top-800": "_margin-top-800_1bnae_399",
  "margin-top-900": "_margin-top-900_1bnae_402",
  "margin-top-1000": "_margin-top-1000_1bnae_405",
  "margin-top-auto": "_margin-top-auto_1bnae_408",
  "margin-bottom-0": "_margin-bottom-0_1bnae_411",
  "margin-bottom-50": "_margin-bottom-50_1bnae_414",
  "margin-bottom-100": "_margin-bottom-100_1bnae_417",
  "margin-bottom-200": "_margin-bottom-200_1bnae_420",
  "margin-bottom-300": "_margin-bottom-300_1bnae_423",
  "margin-bottom-400": "_margin-bottom-400_1bnae_426",
  "margin-bottom-500": "_margin-bottom-500_1bnae_429",
  "margin-bottom-600": "_margin-bottom-600_1bnae_432",
  "margin-bottom-700": "_margin-bottom-700_1bnae_435",
  "margin-bottom-800": "_margin-bottom-800_1bnae_438",
  "margin-bottom-900": "_margin-bottom-900_1bnae_441",
  "margin-bottom-1000": "_margin-bottom-1000_1bnae_444",
  "margin-bottom-auto": "_margin-bottom-auto_1bnae_447",
  "margin-left-0": "_margin-left-0_1bnae_450",
  "margin-left-50": "_margin-left-50_1bnae_453",
  "margin-left-100": "_margin-left-100_1bnae_456",
  "margin-left-200": "_margin-left-200_1bnae_459",
  "margin-left-300": "_margin-left-300_1bnae_462",
  "margin-left-400": "_margin-left-400_1bnae_465",
  "margin-left-500": "_margin-left-500_1bnae_468",
  "margin-left-600": "_margin-left-600_1bnae_471",
  "margin-left-700": "_margin-left-700_1bnae_474",
  "margin-left-800": "_margin-left-800_1bnae_477",
  "margin-left-900": "_margin-left-900_1bnae_480",
  "margin-left-1000": "_margin-left-1000_1bnae_483",
  "margin-left-auto": "_margin-left-auto_1bnae_486",
  "margin-right-0": "_margin-right-0_1bnae_489",
  "margin-right-50": "_margin-right-50_1bnae_492",
  "margin-right-100": "_margin-right-100_1bnae_495",
  "margin-right-200": "_margin-right-200_1bnae_498",
  "margin-right-300": "_margin-right-300_1bnae_501",
  "margin-right-400": "_margin-right-400_1bnae_504",
  "margin-right-500": "_margin-right-500_1bnae_507",
  "margin-right-600": "_margin-right-600_1bnae_510",
  "margin-right-700": "_margin-right-700_1bnae_513",
  "margin-right-800": "_margin-right-800_1bnae_516",
  "margin-right-900": "_margin-right-900_1bnae_519",
  "margin-right-1000": "_margin-right-1000_1bnae_522",
  "margin-right-auto": "_margin-right-auto_1bnae_525",
  "box-shadow-flat-100": "_box-shadow-flat-100_1bnae_528",
  "box-shadow-flat-200": "_box-shadow-flat-200_1bnae_531",
  "box-shadow-elevated-100": "_box-shadow-elevated-100_1bnae_534",
  "border-radius-100": "_border-radius-100_1bnae_537",
  "border-radius-200": "_border-radius-200_1bnae_540",
  "border-radius-300": "_border-radius-300_1bnae_543",
  "border-radius-1000": "_border-radius-1000_1bnae_546",
  "border-width-100": "_border-width-100_1bnae_549",
  "border-width-200": "_border-width-200_1bnae_552",
  "border-width-300": "_border-width-300_1bnae_555",
  border: $,
  "width-auto": "_width-auto_1bnae_561",
  "width-min-content": "_width-min-content_1bnae_564",
  "width-max-content": "_width-max-content_1bnae_567",
  "width-fit-content": "_width-fit-content_1bnae_570",
  "width-full": "_width-full_1bnae_573",
  "width-1/2": "_width-1/2_1bnae_576",
  "width-1/3": "_width-1/3_1bnae_579",
  "width-2/3": "_width-2/3_1bnae_582",
  "width-1/4": "_width-1/4_1bnae_585",
  "width-2/4": "_width-2/4_1bnae_588",
  "width-3/4": "_width-3/4_1bnae_591",
  "width-1/5": "_width-1/5_1bnae_594",
  "width-2/5": "_width-2/5_1bnae_597",
  "width-3/5": "_width-3/5_1bnae_600",
  "width-4/5": "_width-4/5_1bnae_603",
  "width-1/6": "_width-1/6_1bnae_606",
  "width-2/6": "_width-2/6_1bnae_609",
  "width-3/6": "_width-3/6_1bnae_612",
  "width-4/6": "_width-4/6_1bnae_615",
  "width-5/6": "_width-5/6_1bnae_618",
  "width-auto-xs": "_width-auto-xs_1bnae_622",
  "width-min-content-xs": "_width-min-content-xs_1bnae_627",
  "width-max-content-xs": "_width-max-content-xs_1bnae_632",
  "width-fit-content-xs": "_width-fit-content-xs_1bnae_637",
  "width-full-xs": "_width-full-xs_1bnae_642",
  "width-1/2-xs": "_width-1/2-xs_1bnae_647",
  "width-1/3-xs": "_width-1/3-xs_1bnae_652",
  "width-2/3-xs": "_width-2/3-xs_1bnae_657",
  "width-1/4-xs": "_width-1/4-xs_1bnae_662",
  "width-2/4-xs": "_width-2/4-xs_1bnae_667",
  "width-3/4-xs": "_width-3/4-xs_1bnae_672",
  "width-1/5-xs": "_width-1/5-xs_1bnae_677",
  "width-2/5-xs": "_width-2/5-xs_1bnae_682",
  "width-3/5-xs": "_width-3/5-xs_1bnae_687",
  "width-4/5-xs": "_width-4/5-xs_1bnae_692",
  "width-1/6-xs": "_width-1/6-xs_1bnae_697",
  "width-2/6-xs": "_width-2/6-xs_1bnae_702",
  "width-3/6-xs": "_width-3/6-xs_1bnae_707",
  "width-4/6-xs": "_width-4/6-xs_1bnae_712",
  "width-5/6-xs": "_width-5/6-xs_1bnae_717",
  "width-auto-sm": "_width-auto-sm_1bnae_722",
  "width-min-content-sm": "_width-min-content-sm_1bnae_727",
  "width-max-content-sm": "_width-max-content-sm_1bnae_732",
  "width-fit-content-sm": "_width-fit-content-sm_1bnae_737",
  "width-full-sm": "_width-full-sm_1bnae_742",
  "width-1/2-sm": "_width-1/2-sm_1bnae_747",
  "width-1/3-sm": "_width-1/3-sm_1bnae_752",
  "width-2/3-sm": "_width-2/3-sm_1bnae_757",
  "width-1/4-sm": "_width-1/4-sm_1bnae_762",
  "width-2/4-sm": "_width-2/4-sm_1bnae_767",
  "width-3/4-sm": "_width-3/4-sm_1bnae_772",
  "width-1/5-sm": "_width-1/5-sm_1bnae_777",
  "width-2/5-sm": "_width-2/5-sm_1bnae_782",
  "width-3/5-sm": "_width-3/5-sm_1bnae_787",
  "width-4/5-sm": "_width-4/5-sm_1bnae_792",
  "width-1/6-sm": "_width-1/6-sm_1bnae_797",
  "width-2/6-sm": "_width-2/6-sm_1bnae_802",
  "width-3/6-sm": "_width-3/6-sm_1bnae_807",
  "width-4/6-sm": "_width-4/6-sm_1bnae_812",
  "width-5/6-sm": "_width-5/6-sm_1bnae_817",
  "width-auto-md": "_width-auto-md_1bnae_822",
  "width-min-content-md": "_width-min-content-md_1bnae_827",
  "width-max-content-md": "_width-max-content-md_1bnae_832",
  "width-fit-content-md": "_width-fit-content-md_1bnae_837",
  "width-full-md": "_width-full-md_1bnae_842",
  "width-1/2-md": "_width-1/2-md_1bnae_847",
  "width-1/3-md": "_width-1/3-md_1bnae_852",
  "width-2/3-md": "_width-2/3-md_1bnae_857",
  "width-1/4-md": "_width-1/4-md_1bnae_862",
  "width-2/4-md": "_width-2/4-md_1bnae_867",
  "width-3/4-md": "_width-3/4-md_1bnae_872",
  "width-1/5-md": "_width-1/5-md_1bnae_877",
  "width-2/5-md": "_width-2/5-md_1bnae_882",
  "width-3/5-md": "_width-3/5-md_1bnae_887",
  "width-4/5-md": "_width-4/5-md_1bnae_892",
  "width-1/6-md": "_width-1/6-md_1bnae_897",
  "width-2/6-md": "_width-2/6-md_1bnae_902",
  "width-3/6-md": "_width-3/6-md_1bnae_907",
  "width-4/6-md": "_width-4/6-md_1bnae_912",
  "width-5/6-md": "_width-5/6-md_1bnae_917",
  "width-auto-lg": "_width-auto-lg_1bnae_922",
  "width-min-content-lg": "_width-min-content-lg_1bnae_927",
  "width-max-content-lg": "_width-max-content-lg_1bnae_932",
  "width-fit-content-lg": "_width-fit-content-lg_1bnae_937",
  "width-full-lg": "_width-full-lg_1bnae_942",
  "width-1/2-lg": "_width-1/2-lg_1bnae_947",
  "width-1/3-lg": "_width-1/3-lg_1bnae_952",
  "width-2/3-lg": "_width-2/3-lg_1bnae_957",
  "width-1/4-lg": "_width-1/4-lg_1bnae_962",
  "width-2/4-lg": "_width-2/4-lg_1bnae_967",
  "width-3/4-lg": "_width-3/4-lg_1bnae_972",
  "width-1/5-lg": "_width-1/5-lg_1bnae_977",
  "width-2/5-lg": "_width-2/5-lg_1bnae_982",
  "width-3/5-lg": "_width-3/5-lg_1bnae_987",
  "width-4/5-lg": "_width-4/5-lg_1bnae_992",
  "width-1/6-lg": "_width-1/6-lg_1bnae_997",
  "width-2/6-lg": "_width-2/6-lg_1bnae_1002",
  "width-3/6-lg": "_width-3/6-lg_1bnae_1007",
  "width-4/6-lg": "_width-4/6-lg_1bnae_1012",
  "width-5/6-lg": "_width-5/6-lg_1bnae_1017",
  "width-auto-xl": "_width-auto-xl_1bnae_1022",
  "width-min-content-xl": "_width-min-content-xl_1bnae_1027",
  "width-max-content-xl": "_width-max-content-xl_1bnae_1032",
  "width-fit-content-xl": "_width-fit-content-xl_1bnae_1037",
  "width-full-xl": "_width-full-xl_1bnae_1042",
  "width-1/2-xl": "_width-1/2-xl_1bnae_1047",
  "width-1/3-xl": "_width-1/3-xl_1bnae_1052",
  "width-2/3-xl": "_width-2/3-xl_1bnae_1057",
  "width-1/4-xl": "_width-1/4-xl_1bnae_1062",
  "width-2/4-xl": "_width-2/4-xl_1bnae_1067",
  "width-3/4-xl": "_width-3/4-xl_1bnae_1072",
  "width-1/5-xl": "_width-1/5-xl_1bnae_1077",
  "width-2/5-xl": "_width-2/5-xl_1bnae_1082",
  "width-3/5-xl": "_width-3/5-xl_1bnae_1087",
  "width-4/5-xl": "_width-4/5-xl_1bnae_1092",
  "width-1/6-xl": "_width-1/6-xl_1bnae_1097",
  "width-2/6-xl": "_width-2/6-xl_1bnae_1102",
  "width-3/6-xl": "_width-3/6-xl_1bnae_1107",
  "width-4/6-xl": "_width-4/6-xl_1bnae_1112",
  "width-5/6-xl": "_width-5/6-xl_1bnae_1117",
  "width-auto-xxl": "_width-auto-xxl_1bnae_1122",
  "width-min-content-xxl": "_width-min-content-xxl_1bnae_1127",
  "width-max-content-xxl": "_width-max-content-xxl_1bnae_1132",
  "width-fit-content-xxl": "_width-fit-content-xxl_1bnae_1137",
  "width-full-xxl": "_width-full-xxl_1bnae_1142",
  "width-1/2-xxl": "_width-1/2-xxl_1bnae_1147",
  "width-1/3-xxl": "_width-1/3-xxl_1bnae_1152",
  "width-2/3-xxl": "_width-2/3-xxl_1bnae_1157",
  "width-1/4-xxl": "_width-1/4-xxl_1bnae_1162",
  "width-2/4-xxl": "_width-2/4-xxl_1bnae_1167",
  "width-3/4-xxl": "_width-3/4-xxl_1bnae_1172",
  "width-1/5-xxl": "_width-1/5-xxl_1bnae_1177",
  "width-2/5-xxl": "_width-2/5-xxl_1bnae_1182",
  "width-3/5-xxl": "_width-3/5-xxl_1bnae_1187",
  "width-4/5-xxl": "_width-4/5-xxl_1bnae_1192",
  "width-1/6-xxl": "_width-1/6-xxl_1bnae_1197",
  "width-2/6-xxl": "_width-2/6-xxl_1bnae_1202",
  "width-3/6-xxl": "_width-3/6-xxl_1bnae_1207",
  "width-4/6-xxl": "_width-4/6-xxl_1bnae_1212",
  "width-5/6-xxl": "_width-5/6-xxl_1bnae_1217",
  "height-auto": "_height-auto_1bnae_1221",
  "height-min-content": "_height-min-content_1bnae_1224",
  "height-max-content": "_height-max-content_1bnae_1227",
  "height-fit-content": "_height-fit-content_1bnae_1230",
  "height-full": "_height-full_1bnae_1233",
  "height-1/2": "_height-1/2_1bnae_1236",
  "height-1/3": "_height-1/3_1bnae_1239",
  "height-2/3": "_height-2/3_1bnae_1242",
  "height-1/4": "_height-1/4_1bnae_1245",
  "height-2/4": "_height-2/4_1bnae_1248",
  "height-3/4": "_height-3/4_1bnae_1251",
  "height-1/5": "_height-1/5_1bnae_1254",
  "height-2/5": "_height-2/5_1bnae_1257",
  "height-3/5": "_height-3/5_1bnae_1260",
  "height-4/5": "_height-4/5_1bnae_1263",
  "height-1/6": "_height-1/6_1bnae_1266",
  "height-2/6": "_height-2/6_1bnae_1269",
  "height-3/6": "_height-3/6_1bnae_1272",
  "height-4/6": "_height-4/6_1bnae_1275",
  "height-5/6": "_height-5/6_1bnae_1278",
  "height-auto-xs": "_height-auto-xs_1bnae_1282",
  "height-min-content-xs": "_height-min-content-xs_1bnae_1287",
  "height-max-content-xs": "_height-max-content-xs_1bnae_1292",
  "height-fit-content-xs": "_height-fit-content-xs_1bnae_1297",
  "height-full-xs": "_height-full-xs_1bnae_1302",
  "height-1/2-xs": "_height-1/2-xs_1bnae_1307",
  "height-1/3-xs": "_height-1/3-xs_1bnae_1312",
  "height-2/3-xs": "_height-2/3-xs_1bnae_1317",
  "height-1/4-xs": "_height-1/4-xs_1bnae_1322",
  "height-2/4-xs": "_height-2/4-xs_1bnae_1327",
  "height-3/4-xs": "_height-3/4-xs_1bnae_1332",
  "height-1/5-xs": "_height-1/5-xs_1bnae_1337",
  "height-2/5-xs": "_height-2/5-xs_1bnae_1342",
  "height-3/5-xs": "_height-3/5-xs_1bnae_1347",
  "height-4/5-xs": "_height-4/5-xs_1bnae_1352",
  "height-1/6-xs": "_height-1/6-xs_1bnae_1357",
  "height-2/6-xs": "_height-2/6-xs_1bnae_1362",
  "height-3/6-xs": "_height-3/6-xs_1bnae_1367",
  "height-4/6-xs": "_height-4/6-xs_1bnae_1372",
  "height-5/6-xs": "_height-5/6-xs_1bnae_1377",
  "height-auto-sm": "_height-auto-sm_1bnae_1382",
  "height-min-content-sm": "_height-min-content-sm_1bnae_1387",
  "height-max-content-sm": "_height-max-content-sm_1bnae_1392",
  "height-fit-content-sm": "_height-fit-content-sm_1bnae_1397",
  "height-full-sm": "_height-full-sm_1bnae_1402",
  "height-1/2-sm": "_height-1/2-sm_1bnae_1407",
  "height-1/3-sm": "_height-1/3-sm_1bnae_1412",
  "height-2/3-sm": "_height-2/3-sm_1bnae_1417",
  "height-1/4-sm": "_height-1/4-sm_1bnae_1422",
  "height-2/4-sm": "_height-2/4-sm_1bnae_1427",
  "height-3/4-sm": "_height-3/4-sm_1bnae_1432",
  "height-1/5-sm": "_height-1/5-sm_1bnae_1437",
  "height-2/5-sm": "_height-2/5-sm_1bnae_1442",
  "height-3/5-sm": "_height-3/5-sm_1bnae_1447",
  "height-4/5-sm": "_height-4/5-sm_1bnae_1452",
  "height-1/6-sm": "_height-1/6-sm_1bnae_1457",
  "height-2/6-sm": "_height-2/6-sm_1bnae_1462",
  "height-3/6-sm": "_height-3/6-sm_1bnae_1467",
  "height-4/6-sm": "_height-4/6-sm_1bnae_1472",
  "height-5/6-sm": "_height-5/6-sm_1bnae_1477",
  "height-auto-md": "_height-auto-md_1bnae_1482",
  "height-min-content-md": "_height-min-content-md_1bnae_1487",
  "height-max-content-md": "_height-max-content-md_1bnae_1492",
  "height-fit-content-md": "_height-fit-content-md_1bnae_1497",
  "height-full-md": "_height-full-md_1bnae_1502",
  "height-1/2-md": "_height-1/2-md_1bnae_1507",
  "height-1/3-md": "_height-1/3-md_1bnae_1512",
  "height-2/3-md": "_height-2/3-md_1bnae_1517",
  "height-1/4-md": "_height-1/4-md_1bnae_1522",
  "height-2/4-md": "_height-2/4-md_1bnae_1527",
  "height-3/4-md": "_height-3/4-md_1bnae_1532",
  "height-1/5-md": "_height-1/5-md_1bnae_1537",
  "height-2/5-md": "_height-2/5-md_1bnae_1542",
  "height-3/5-md": "_height-3/5-md_1bnae_1547",
  "height-4/5-md": "_height-4/5-md_1bnae_1552",
  "height-1/6-md": "_height-1/6-md_1bnae_1557",
  "height-2/6-md": "_height-2/6-md_1bnae_1562",
  "height-3/6-md": "_height-3/6-md_1bnae_1567",
  "height-4/6-md": "_height-4/6-md_1bnae_1572",
  "height-5/6-md": "_height-5/6-md_1bnae_1577",
  "height-auto-lg": "_height-auto-lg_1bnae_1582",
  "height-min-content-lg": "_height-min-content-lg_1bnae_1587",
  "height-max-content-lg": "_height-max-content-lg_1bnae_1592",
  "height-fit-content-lg": "_height-fit-content-lg_1bnae_1597",
  "height-full-lg": "_height-full-lg_1bnae_1602",
  "height-1/2-lg": "_height-1/2-lg_1bnae_1607",
  "height-1/3-lg": "_height-1/3-lg_1bnae_1612",
  "height-2/3-lg": "_height-2/3-lg_1bnae_1617",
  "height-1/4-lg": "_height-1/4-lg_1bnae_1622",
  "height-2/4-lg": "_height-2/4-lg_1bnae_1627",
  "height-3/4-lg": "_height-3/4-lg_1bnae_1632",
  "height-1/5-lg": "_height-1/5-lg_1bnae_1637",
  "height-2/5-lg": "_height-2/5-lg_1bnae_1642",
  "height-3/5-lg": "_height-3/5-lg_1bnae_1647",
  "height-4/5-lg": "_height-4/5-lg_1bnae_1652",
  "height-1/6-lg": "_height-1/6-lg_1bnae_1657",
  "height-2/6-lg": "_height-2/6-lg_1bnae_1662",
  "height-3/6-lg": "_height-3/6-lg_1bnae_1667",
  "height-4/6-lg": "_height-4/6-lg_1bnae_1672",
  "height-5/6-lg": "_height-5/6-lg_1bnae_1677",
  "height-auto-xl": "_height-auto-xl_1bnae_1682",
  "height-min-content-xl": "_height-min-content-xl_1bnae_1687",
  "height-max-content-xl": "_height-max-content-xl_1bnae_1692",
  "height-fit-content-xl": "_height-fit-content-xl_1bnae_1697",
  "height-full-xl": "_height-full-xl_1bnae_1702",
  "height-1/2-xl": "_height-1/2-xl_1bnae_1707",
  "height-1/3-xl": "_height-1/3-xl_1bnae_1712",
  "height-2/3-xl": "_height-2/3-xl_1bnae_1717",
  "height-1/4-xl": "_height-1/4-xl_1bnae_1722",
  "height-2/4-xl": "_height-2/4-xl_1bnae_1727",
  "height-3/4-xl": "_height-3/4-xl_1bnae_1732",
  "height-1/5-xl": "_height-1/5-xl_1bnae_1737",
  "height-2/5-xl": "_height-2/5-xl_1bnae_1742",
  "height-3/5-xl": "_height-3/5-xl_1bnae_1747",
  "height-4/5-xl": "_height-4/5-xl_1bnae_1752",
  "height-1/6-xl": "_height-1/6-xl_1bnae_1757",
  "height-2/6-xl": "_height-2/6-xl_1bnae_1762",
  "height-3/6-xl": "_height-3/6-xl_1bnae_1767",
  "height-4/6-xl": "_height-4/6-xl_1bnae_1772",
  "height-5/6-xl": "_height-5/6-xl_1bnae_1777",
  "height-auto-xxl": "_height-auto-xxl_1bnae_1782",
  "height-min-content-xxl": "_height-min-content-xxl_1bnae_1787",
  "height-max-content-xxl": "_height-max-content-xxl_1bnae_1792",
  "height-fit-content-xxl": "_height-fit-content-xxl_1bnae_1797",
  "height-full-xxl": "_height-full-xxl_1bnae_1802",
  "height-1/2-xxl": "_height-1/2-xxl_1bnae_1807",
  "height-1/3-xxl": "_height-1/3-xxl_1bnae_1812",
  "height-2/3-xxl": "_height-2/3-xxl_1bnae_1817",
  "height-1/4-xxl": "_height-1/4-xxl_1bnae_1822",
  "height-2/4-xxl": "_height-2/4-xxl_1bnae_1827",
  "height-3/4-xxl": "_height-3/4-xxl_1bnae_1832",
  "height-1/5-xxl": "_height-1/5-xxl_1bnae_1837",
  "height-2/5-xxl": "_height-2/5-xxl_1bnae_1842",
  "height-3/5-xxl": "_height-3/5-xxl_1bnae_1847",
  "height-4/5-xxl": "_height-4/5-xxl_1bnae_1852",
  "height-1/6-xxl": "_height-1/6-xxl_1bnae_1857",
  "height-2/6-xxl": "_height-2/6-xxl_1bnae_1862",
  "height-3/6-xxl": "_height-3/6-xxl_1bnae_1867",
  "height-4/6-xxl": "_height-4/6-xxl_1bnae_1872",
  "height-5/6-xxl": "_height-5/6-xxl_1bnae_1877",
  "display-none": "_display-none_1bnae_1881",
  "display-block": "_display-block_1bnae_1884",
  "display-inline": "_display-inline_1bnae_1887",
  "display-inline-block": "_display-inline-block_1bnae_1890",
  "display-flex": "_display-flex_1bnae_1893",
  "display-inline-flex": "_display-inline-flex_1bnae_1896",
  "display-inherit": "_display-inherit_1bnae_1899",
  "display-none-xs": "_display-none-xs_1bnae_1903",
  "display-block-xs": "_display-block-xs_1bnae_1908",
  "display-inline-xs": "_display-inline-xs_1bnae_1913",
  "display-inline-block-xs": "_display-inline-block-xs_1bnae_1918",
  "display-flex-xs": "_display-flex-xs_1bnae_1923",
  "display-inline-flex-xs": "_display-inline-flex-xs_1bnae_1928",
  "display-inherit-xs": "_display-inherit-xs_1bnae_1933",
  "display-none-sm": "_display-none-sm_1bnae_1938",
  "display-block-sm": "_display-block-sm_1bnae_1943",
  "display-inline-sm": "_display-inline-sm_1bnae_1948",
  "display-inline-block-sm": "_display-inline-block-sm_1bnae_1953",
  "display-flex-sm": "_display-flex-sm_1bnae_1958",
  "display-inline-flex-sm": "_display-inline-flex-sm_1bnae_1963",
  "display-inherit-sm": "_display-inherit-sm_1bnae_1968",
  "display-none-md": "_display-none-md_1bnae_1973",
  "display-block-md": "_display-block-md_1bnae_1978",
  "display-inline-md": "_display-inline-md_1bnae_1983",
  "display-inline-block-md": "_display-inline-block-md_1bnae_1988",
  "display-flex-md": "_display-flex-md_1bnae_1993",
  "display-inline-flex-md": "_display-inline-flex-md_1bnae_1998",
  "display-inherit-md": "_display-inherit-md_1bnae_2003",
  "display-none-lg": "_display-none-lg_1bnae_2008",
  "display-block-lg": "_display-block-lg_1bnae_2013",
  "display-inline-lg": "_display-inline-lg_1bnae_2018",
  "display-inline-block-lg": "_display-inline-block-lg_1bnae_2023",
  "display-flex-lg": "_display-flex-lg_1bnae_2028",
  "display-inline-flex-lg": "_display-inline-flex-lg_1bnae_2033",
  "display-inherit-lg": "_display-inherit-lg_1bnae_2038",
  "display-none-xl": "_display-none-xl_1bnae_2043",
  "display-block-xl": "_display-block-xl_1bnae_2048",
  "display-inline-xl": "_display-inline-xl_1bnae_2053",
  "display-inline-block-xl": "_display-inline-block-xl_1bnae_2058",
  "display-flex-xl": "_display-flex-xl_1bnae_2063",
  "display-inline-flex-xl": "_display-inline-flex-xl_1bnae_2068",
  "display-inherit-xl": "_display-inherit-xl_1bnae_2073",
  "display-none-xxl": "_display-none-xxl_1bnae_2078",
  "display-block-xxl": "_display-block-xxl_1bnae_2083",
  "display-inline-xxl": "_display-inline-xxl_1bnae_2088",
  "display-inline-block-xxl": "_display-inline-block-xxl_1bnae_2093",
  "display-flex-xxl": "_display-flex-xxl_1bnae_2098",
  "display-inline-flex-xxl": "_display-inline-flex-xxl_1bnae_2103",
  "display-inherit-xxl": "_display-inherit-xxl_1bnae_2108",
  "background-color-inherit": "_background-color-inherit_1bnae_2112",
  "color-inherit": "_color-inherit_1bnae_2115",
  "color-bg-level-1": "_color-bg-level-1_1bnae_2118",
  "color-bg-level-2": "_color-bg-level-2_1bnae_2121",
  "color-bg-level-3": "_color-bg-level-3_1bnae_2124",
  "color-bg-level-1-inverted": "_color-bg-level-1-inverted_1bnae_2127",
  "color-bg-level-2-inverted": "_color-bg-level-2-inverted_1bnae_2130",
  "color-bg-level-3-inverted": "_color-bg-level-3-inverted_1bnae_2133",
  "color-bg-overlay-42": "_color-bg-overlay-42_1bnae_2136",
  "color-bg-overlay-18": "_color-bg-overlay-18_1bnae_2139",
  "color-bg-overlay-80": "_color-bg-overlay-80_1bnae_2142",
  "color-c-high-contrast": "_color-c-high-contrast_1bnae_2145",
  "color-c-mid-contrast": "_color-c-mid-contrast_1bnae_2148",
  "color-c-inverted": "_color-c-inverted_1bnae_2151",
  "color-c-disabled": "_color-c-disabled_1bnae_2154",
  "color-c-hover": "_color-c-hover_1bnae_2157",
  "color-c-pressed": "_color-c-pressed_1bnae_2160",
  "color-s-primary": "_color-s-primary_1bnae_2163",
  "color-s-secondary": "_color-s-secondary_1bnae_2166",
  "color-s-disabled": "_color-s-disabled_1bnae_2169",
  "color-dc-standard": "_color-dc-standard_1bnae_2172",
  "color-dc-standard-disabled": "_color-dc-standard-disabled_1bnae_2175",
  "color-dc-accent": "_color-dc-accent_1bnae_2178",
  "color-dc-accent-disabled": "_color-dc-accent-disabled_1bnae_2181",
  "color-ds-standard": "_color-ds-standard_1bnae_2184",
  "color-ds-standard-disabled": "_color-ds-standard-disabled_1bnae_2187",
  "color-ds-accent": "_color-ds-accent_1bnae_2190",
  "color-ds-accent-disabled": "_color-ds-accent-disabled_1bnae_2193",
  "color-ds-glass": "_color-ds-glass_1bnae_2196",
  "color-sl-hover": "_color-sl-hover_1bnae_2199",
  "color-sl-pressed": "_color-sl-pressed_1bnae_2202",
  "color-sl-focused": "_color-sl-focused_1bnae_2205",
  "color-div-default": "_color-div-default_1bnae_2208",
  "color-sig-informational": "_color-sig-informational_1bnae_2211",
  "color-sig-success": "_color-sig-success_1bnae_2214",
  "color-sig-error": "_color-sig-error_1bnae_2217",
  "color-sig-warning": "_color-sig-warning_1bnae_2220",
  "background-color-bg-level-1": "_background-color-bg-level-1_1bnae_2328",
  "background-color-bg-level-2": "_background-color-bg-level-2_1bnae_2331",
  "background-color-bg-level-3": "_background-color-bg-level-3_1bnae_2334",
  "background-color-bg-level-1-inverted": "_background-color-bg-level-1-inverted_1bnae_2337",
  "background-color-bg-level-2-inverted": "_background-color-bg-level-2-inverted_1bnae_2340",
  "background-color-bg-level-3-inverted": "_background-color-bg-level-3-inverted_1bnae_2343",
  "background-color-bg-overlay-42": "_background-color-bg-overlay-42_1bnae_2346",
  "background-color-bg-overlay-18": "_background-color-bg-overlay-18_1bnae_2349",
  "background-color-bg-overlay-80": "_background-color-bg-overlay-80_1bnae_2352",
  "background-color-c-high-contrast": "_background-color-c-high-contrast_1bnae_2355",
  "background-color-c-mid-contrast": "_background-color-c-mid-contrast_1bnae_2358",
  "background-color-c-inverted": "_background-color-c-inverted_1bnae_2361",
  "background-color-c-disabled": "_background-color-c-disabled_1bnae_2364",
  "background-color-c-hover": "_background-color-c-hover_1bnae_2367",
  "background-color-c-pressed": "_background-color-c-pressed_1bnae_2370",
  "background-color-s-primary": "_background-color-s-primary_1bnae_2373",
  "background-color-s-secondary": "_background-color-s-secondary_1bnae_2376",
  "background-color-s-disabled": "_background-color-s-disabled_1bnae_2379",
  "background-color-dc-standard": "_background-color-dc-standard_1bnae_2382",
  "background-color-dc-standard-disabled": "_background-color-dc-standard-disabled_1bnae_2385",
  "background-color-dc-accent": "_background-color-dc-accent_1bnae_2388",
  "background-color-dc-accent-disabled": "_background-color-dc-accent-disabled_1bnae_2391",
  "background-color-ds-standard": "_background-color-ds-standard_1bnae_2394",
  "background-color-ds-standard-disabled": "_background-color-ds-standard-disabled_1bnae_2397",
  "background-color-ds-accent": "_background-color-ds-accent_1bnae_2400",
  "background-color-ds-accent-disabled": "_background-color-ds-accent-disabled_1bnae_2403",
  "background-color-ds-glass": "_background-color-ds-glass_1bnae_2406",
  "background-color-sl-hover": "_background-color-sl-hover_1bnae_2409",
  "background-color-sl-pressed": "_background-color-sl-pressed_1bnae_2412",
  "background-color-sl-focused": "_background-color-sl-focused_1bnae_2415",
  "background-color-div-default": "_background-color-div-default_1bnae_2418",
  "background-color-sig-informational": "_background-color-sig-informational_1bnae_2421",
  "background-color-sig-success": "_background-color-sig-success_1bnae_2424",
  "background-color-sig-error": "_background-color-sig-error_1bnae_2427",
  "background-color-sig-warning": "_background-color-sig-warning_1bnae_2430",
  "border-color-bg-level-1": "_border-color-bg-level-1_1bnae_2538",
  "border-color-bg-level-2": "_border-color-bg-level-2_1bnae_2541",
  "border-color-bg-level-3": "_border-color-bg-level-3_1bnae_2544",
  "border-color-bg-level-1-inverted": "_border-color-bg-level-1-inverted_1bnae_2547",
  "border-color-bg-level-2-inverted": "_border-color-bg-level-2-inverted_1bnae_2550",
  "border-color-bg-level-3-inverted": "_border-color-bg-level-3-inverted_1bnae_2553",
  "border-color-bg-overlay-42": "_border-color-bg-overlay-42_1bnae_2556",
  "border-color-bg-overlay-18": "_border-color-bg-overlay-18_1bnae_2559",
  "border-color-bg-overlay-80": "_border-color-bg-overlay-80_1bnae_2562",
  "border-color-c-high-contrast": "_border-color-c-high-contrast_1bnae_2565",
  "border-color-c-mid-contrast": "_border-color-c-mid-contrast_1bnae_2568",
  "border-color-c-inverted": "_border-color-c-inverted_1bnae_2571",
  "border-color-c-disabled": "_border-color-c-disabled_1bnae_2574",
  "border-color-c-hover": "_border-color-c-hover_1bnae_2577",
  "border-color-c-pressed": "_border-color-c-pressed_1bnae_2580",
  "border-color-s-primary": "_border-color-s-primary_1bnae_2583",
  "border-color-s-secondary": "_border-color-s-secondary_1bnae_2586",
  "border-color-s-disabled": "_border-color-s-disabled_1bnae_2589",
  "border-color-dc-standard": "_border-color-dc-standard_1bnae_2592",
  "border-color-dc-standard-disabled": "_border-color-dc-standard-disabled_1bnae_2595",
  "border-color-dc-accent": "_border-color-dc-accent_1bnae_2598",
  "border-color-dc-accent-disabled": "_border-color-dc-accent-disabled_1bnae_2601",
  "border-color-ds-standard": "_border-color-ds-standard_1bnae_2604",
  "border-color-ds-standard-disabled": "_border-color-ds-standard-disabled_1bnae_2607",
  "border-color-ds-accent": "_border-color-ds-accent_1bnae_2610",
  "border-color-ds-accent-disabled": "_border-color-ds-accent-disabled_1bnae_2613",
  "border-color-ds-glass": "_border-color-ds-glass_1bnae_2616",
  "border-color-sl-hover": "_border-color-sl-hover_1bnae_2619",
  "border-color-sl-pressed": "_border-color-sl-pressed_1bnae_2622",
  "border-color-sl-focused": "_border-color-sl-focused_1bnae_2625",
  "border-color-div-default": "_border-color-div-default_1bnae_2628",
  "border-color-sig-informational": "_border-color-sig-informational_1bnae_2631",
  "border-color-sig-success": "_border-color-sig-success_1bnae_2634",
  "border-color-sig-error": "_border-color-sig-error_1bnae_2637",
  "border-color-sig-warning": "_border-color-sig-warning_1bnae_2640"
}, j = v.forwardRef(
  ({
    children: a,
    className: _,
    asChild: n,
    width: i,
    height: d,
    display: o,
    padding: l,
    margin: p,
    backgroundColor: r,
    color: s,
    borderWidth: b,
    borderColor: c,
    borderRadius: m,
    ...h
  }, w) => {
    const y = k(
      t(g("height", d), e),
      t(g("width", i), e),
      t(g("display", o), e),
      t(x("margin", p), e),
      t(x("padding", l), e),
      {
        [e[`background-color-${r}`]]: r,
        [e[`color-${s}`]]: s,
        [e[`border-width-${b}`]]: b,
        [e[`border-color-${c}`]]: c,
        [e[`border-radius-${m}`]]: m,
        [e.border]: b,
        [e[`box-shadow-${h.boxShadow}`]]: h.boxShadow
      },
      _
    );
    return /* @__PURE__ */ u(n ? f : "div", { ref: w, className: y, ...h, children: a });
  }
);
j.displayName = "Layout";
export {
  j as L,
  t as j,
  g as r
};
//# sourceMappingURL=layout.BROMuy9M.js.map
